import React from 'react';
import { Box, Link, Stack, Typography } from '@mui/material';
import MssTooltip from './MssTooltip';

function MssAlert({
  id,
  severity,
  type,
  icon,
  alt,
  title,
  titleLink,
  subTitle,
  isBodyUnderTitle,
  children,
  ...rest
}) {
  return (
    <Box
      id={`${id}__box_wrapper`}
      {...rest}
      className={`mss__alert ${severity} ${type}`}
      sx={{ p: 1 }}
    >
      <Stack
        id={`${id}__stack_wrapper`}
        direction="row"
        spacing={1}
        sx={{ alignItems: 'flex-start' }}
      >
        {icon && (
          <Box
            id={`${id}__box_image_wrapper`}
            sx={{
              height: '40px',
              width: '40px',
              margin: '0 auto',
              minHeight: '4px',
              minWidth: '40px',
            }}
          >
            <img id={`${id}__imageIcon`} src={icon} alt={alt} />
          </Box>
        )}
        <Box sx={{ mb: 0 }}>
          {titleLink ? (
            <MssTooltip id={`${id}__tooltip`}>
              <Link
                href={titleLink}
                id={`${id}__link_titleWrapper`}
                target="_blank"
                underline="hover"
                sx={{
                  cursor: 'pointer',
                  fontWeight: 600,
                }}
              >
                <Typography id={`${id}__text_title`} component="h3" variant="h6">
                  {title}
                </Typography>
              </Link>
            </MssTooltip>
          ) : (
            <Typography id={`${id}__text_title`} component="h3" variant="h6">
              {title}
            </Typography>
          )}

          {subTitle && (
            <Typography
              id={`${id}__text_subTitle`}
              component="p"
              variant="smallest"
              sx={{ fontStyle: 'italic' }}
            >
              {subTitle}
            </Typography>
          )}

          {isBodyUnderTitle ? (
            <Box
              id={`${id}__box_children_nonXsScreen`}
              className="alertBody mt-0 d-none d-sm-block"
            >
              {children}
            </Box>
          ) : (
            ''
          )}
        </Box>
      </Stack>

      {isBodyUnderTitle ? (
        <Box id={`${id}__box_children_smNone`} className="alertBody d-block d-sm-none">
          {children}
        </Box>
      ) : (
        <Box className="alertBody d-block" id={`${id}__box_children_dblock`}>
          {children}
        </Box>
      )}
    </Box>
  );
}

export default MssAlert;
